import { memo, ReactNode } from 'react';
import { Navigate, Outlet } from 'react-router';
import ROUTES from 'shared/constants/routes';
import { ErrorBoundaryWrapper } from 'shared/components/ErrorBoundaryWrapper/errorBoundaryWrapper';
import { useSelector } from 'react-redux';
import {
  getIsRegUsingLink,
  getPollId,
} from 'pages/login/store/selectors/loginSelectors';
import { getInviteHash } from 'pages/invitePage/model/selectors/ownRespondentSelectors';

type TLandingLayoutRoute = {
  isAuth: boolean;
  children?: ReactNode;
};

const LoginLayoutRoute = ({ isAuth, children }: TLandingLayoutRoute) => {
  const poll_id = useSelector(getPollId);
  const invite_hash = useSelector(getInviteHash);
  const isRegUsingLink = useSelector(getIsRegUsingLink);
  console.log('LOGIN_LAYOUT', isAuth);

  if (isAuth) {
    if (poll_id) {
      return <Navigate to={`${ROUTES.POLLS.ROUTE}/${poll_id}`} replace />; // TODO Изменить страницу навигации
    } else if (invite_hash || isRegUsingLink) {
      return <Navigate to={`${ROUTES.INVITE.ROUTE}`} replace />; // TODO Изменить страницу навигации
    } else {
      return <Navigate to={ROUTES.TESTS.ROUTE} replace />; // TODO Изменить страницу навигации
    }
  }

  return (
    <ErrorBoundaryWrapper>
      <div className="container">
        <div className="wrapper">
          <main className="main--outnav">{children ?? <Outlet />}</main>
        </div>
      </div>
    </ErrorBoundaryWrapper>
  );
};

export default memo(LoginLayoutRoute);
